import CustomButton2 from "../CustomButton2";
import CustomView from "../CustomView";
import "./index.scss";

const AlertCloseModal = ({
  showAlert,
  setShowAlert,
  setShowModal,
}: //   setShowModal,
{
  showAlert: boolean;
  setShowAlert: (event: boolean) => void;
  setShowModal: (event: string) => void;
}) => {
  return (
    <>
      {showAlert && (
        <div>
          <div className="dark-layout" onClick={() => setShowAlert(false)}></div>
          <div className="close-alert">
            <div className="close-alert-content">تغییرات نادیده گرفته شود؟</div>
            <CustomView.Row>
              <CustomView.Column small={6}>
                <CustomButton2
                  onClick={() => {
                    setShowModal("NONE");
                    setShowAlert(false);
                  }}
                  title="بستن فرم"
                  type="danger"
                />
              </CustomView.Column>
              <CustomView.Column small={6}>
                <CustomButton2
                  //   isLoading={isLoading}
                  onClick={() => {
                    setShowAlert(false);
                  }}
                  title="بازگشت به فرم"
                />
              </CustomView.Column>
            </CustomView.Row>
          </div>
        </div>
      )}
    </>
  );
};

export default AlertCloseModal;
